import { API } from "./api";

let socket = null;
let retry = 1000;
const listeners = new Set();

function connect() {
  if (socket && (socket.readyState === WebSocket.CONNECTING || socket.readyState === WebSocket.OPEN)) return;
  const token = localStorage.getItem("egncy_token");
  if (!token) return;
  const url = `${API.replace(/^http/, "ws")}/ws?token=${encodeURIComponent(token)}`;
  socket = new WebSocket(url);
  socket.onopen = () => {
    retry = 1000;
  };
  socket.onmessage = (e) => {
    try {
      const data = JSON.parse(e.data);
      listeners.forEach((cb) => cb(data));
    } catch (err) {
      console.warn("Realtime: could not parse event", err?.message);
    }
  };
  socket.onclose = () => {
    socket = null;
    if (listeners.size > 0) {
      setTimeout(connect, retry);
      retry = Math.min(retry * 2, 30000);
    }
  };
  socket.onerror = (err) => {
    console.warn("Realtime: websocket error, reconnecting…", err?.message || "");
    try { socket?.close(); } catch (closeErr) {
      console.warn("Realtime: error closing socket", closeErr?.message);
    }
  };
}

// Subscribe to realtime events. Returns an unsubscribe function.
export function subscribeRealtime(callback) {
  listeners.add(callback);
  connect();
  return () => {
    listeners.delete(callback);
    if (listeners.size === 0 && socket) {
      try { socket.close(); } catch (err) {
        console.warn("Realtime: error closing socket", err?.message);
      }
      socket = null;
    }
  };
}
